import React from 'react'
import { Filter, FilterComponent } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './types/config'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps>
}

interface ComponentProps {}
interface SearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  includeRefreshSearch?: boolean
}

export const Search: React.FC<SearchProps> = (props) => {
  return <FilterComponent options={filterOptions} {...props} />
}
